export interface FacilityAddress {
  Address1: string;
  Address2: string;
  City: string;
  Country: string;
  County: string;
  State: string;
  Zip: string;
}

export interface FacilitySystem {
  Id: string;
  Name: string;
}

export class FacilityEntity {
  Id: string;
  Name: string;
  Address?: FacilityAddress
}


interface ProvidesSystemFacility {
  Id: string;
  Facility?: FacilityEntity;
  System?: FacilitySystem;
}

export class FacilityModel {
  id: string;
  Id: string;
  name: string;
  Name: string;
  address1: string;
  address2: string;
  city: string;
  state: string;
  zip: string;
  physicians: Array<any>;
  staff: Array<any>;
  phoneNumber: string;
  faxNumber: string;
  contactName: string;
  contactEmail: string;
  address: string;
  visible: boolean;
  Facility?: FacilityEntity;
  Address?: FacilityAddress;
  System?: FacilitySystem;

  constructor(location?: FacilityDTO) {
    location = location || <FacilityDTO>{};

    Object.assign(this, location);
    this.id = location.Id || null;
    const Facility = location.Facility || <FacilityEntity>{};
    this.name = Facility.Name || "";

    const Address = this.Address = Facility.Address || <FacilityAddress>{};
    this.address1 = Address.Address1 || "";
    this.address2 = Address.Address2 || "";
    this.city = Address.City || "";
    this.state = Address.State || null;
    this.zip = Address.Zip || "";


    this.staff = (location.Users || []).filter(user => user.Role === "staff");
    this.phoneNumber = location.PhoneNumber || "";
    this.faxNumber = location.Fax || "";
    this.contactName = location.ContactName || "";
    this.contactEmail = location.ContactEmail || "";
    this.visible = location.Visible;
  }
}

export class FacilityDTO {
  Id: string;
  Name: string;
  Facility?: FacilityEntity;
  System?: FacilitySystem;
  Address1: string;
  Address2: string;
  City: string;
  State: string;
  Zip: string;
  Users: Array<any>;
  PhoneNumber: string;
  Fax: string;
  ContactName: string;
  ContactEmail: string;
  Visible: boolean;

  constructor(facility?: FacilityModel) {
    facility = facility || <FacilityModel>{};

    this.Id = facility.id || null;
    this.Name = facility.name || "";
    this.Address1 = facility.address1 || "";
    this.Address2 = facility.address2 || "";
    this.City = facility.city || "";
    this.State = facility.state || null;
    this.Zip = facility.zip || "";
    this.Users = [].concat(facility.physicians, facility.staff);
    this.PhoneNumber = facility.phoneNumber || "";
    this.Fax = facility.faxNumber || "";
    this.ContactName = facility.contactName || "";
    this.ContactEmail = facility.contactEmail || "";
    this.Visible = facility.visible
  }
}



// WEBPACK FOOTER //
// /Users/maxsheikhizadeh/Desktop/GEN/physician-portal/src/app/shared/models/location.model.ts